// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4d-1";
export var standaloneTable = "_4d-0";